import { render } from "./CapitalHistory.vue?vue&type=template&id=cf9e799e&scoped=true"
import script from "./CapitalHistory.vue?vue&type=script&lang=js"
export * from "./CapitalHistory.vue?vue&type=script&lang=js"

import "./CapitalHistory.vue?vue&type=style&index=0&id=cf9e799e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9e799e"]])

export default __exports__